/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import UserFilterPopup from '../filterForm';
import PaginationApp from 'components/pagination';
import timezoneToDate from 'common/helpers/timezoneToDate';
import formatDate from 'common/helpers/formatDate';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  data: { data: []; count: number };
  loading: boolean;
}

export default function EntranceExitTimesTable({ data, loading }: IProps) {
  const { attendancesRequestAction } = useActions();
  const [meta, setMeta] = useState({ keyword: '' });
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);

  const fetchData = () => {
    attendancesRequestAction(meta, page, size);
  };

  useEffect(() => {
    fetchData();
  }, [meta, page, size]);

  const handleChangePage = (page: number) => {
    setPage(page);
  };

  const handleChangePageSize = (page_size: number) => {
    setSize(page_size);
  };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, keyword: e })}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
            value={meta.keyword}
          />
          <UserFilterPopup setFilter={setMeta} filter={meta} />
        </S.Head>
        <Gap size="20px" />
        {!loading && !data?.data?.length ? (
          <S.P>No result was found for this search query </S.P>
        ) : (
          <AppTable
            headers={[
              { id: 1, title: 'ID', dir: 'left' },
              { id: 2, title: 'EMP Code', dir: 'left' },
              { id: 3, title: 'Name', dir: 'left' },
              { id: 4, title: 'Email', dir: 'left' },
              { id: 5, title: 'Type', dir: 'left' },
              { id: 6, title: 'Date', dir: 'left' },
              { id: 7, title: 'Gate', dir: 'left' }
            ]}
            data={data?.data}
            loading={loading}
            altanfeethiFields={{
              id: (item: T.Pages.Attendances) => <S.Div className="text-left">{item?.userId}</S.Div>,
              emp_code: (item: T.Pages.Attendances) => <S.Div className="text-left">{item.employeeId}</S.Div>,
              name: (item: T.Pages.Attendances) => (
                <S.Div className="text-left capital">
                  {item.user.displayName?.length > 20
                    ? item.user.displayName.substring(0, 20) + '... '
                    : item.user.displayName}
                </S.Div>
              ),
              email: (item: T.Pages.Attendances) => (
                <S.Div className="text-left">
                  {item.user.mail.length > 25 ? item.user.mail.substring(0, 25) + '...' : item.user.mail}
                </S.Div>
              ),
              type: (item: T.Pages.Attendances) => (
                <S.Div className="text-left">{item.transactionType === 'IN' ? 'IN' : 'OUT'}</S.Div>
              ),
              date: (item: T.Pages.Attendances) => (
                <S.Div className="text-left">{formatDate(item.transactionDate) || ''}</S.Div>
              ),
              gate: (item: T.Pages.Attendances) => {
                return <S.Div className="text-left">{item.machineId || '-'}</S.Div>;
              }
            }}
          />
        )}
      </PanelBoxLayout>
      {data?.count ? (
        <PaginationApp
          page={page}
          count={data?.count}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data?.count}
          pageSize={size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
